import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
export default function FadeIn(_ref) {
  var children = _ref.children,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? '700ms' : _ref$duration;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: _JSXStyle.dynamic([["1534071656", [duration]]]) + " " + 'container',
      children: children
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "1534071656",
      dynamic: [duration],
      children: [".container.__jsx-style-dynamic-selector{-webkit-animation-name:container-show;-webkit-animation-name:container-show-__jsx-style-dynamic-selector;animation-name:container-show-__jsx-style-dynamic-selector;-webkit-animation-duration:".concat(duration, ";-webkit-animation-duration:").concat(duration, ";animation-duration:").concat(duration, ";}"), "@-webkit-keyframes container-show{0%.__jsx-style-dynamic-selector{opacity:0;}100%.__jsx-style-dynamic-selector{opacity:1;}}", "@-webkit-keyframes container-show-__jsx-style-dynamic-selector{0%{opacity:0;}100%{opacity:1;}}", "@keyframes container-show-__jsx-style-dynamic-selector{0%{opacity:0;}100%{opacity:1;}}"]
    })]
  });
}